import {
  ArrowLeft,
  ArrowRight,
  AtSign,
  ChevronDown,
  CircleCheck,
  GraduationCap,
  Instagram,
  Mail,
  Menu,
  Pause,
  Play,
  Plus,
  Rocket,
  SkipForward,
  Trash2,
  Trophy,
  User,
  Users,
  Video,
  type LucideIcon,
} from 'lucide-react';
import { useClassName } from './useClassName';
import type { SxProps } from './sxProps';
import { styleRule } from './styleRule';

type IconProps = Omit<React.SVGProps<SVGSVGElement>, 'color'> & {
  sx?: SxProps;
};

function makeIcon(LucideIconComponent: LucideIcon) {
  return function AppIcon({ sx, className, ...rest }: IconProps) {
    const fontSize = sx?.fontSize;
    const color = sx?.color;
    const {
      className: resolvedClass,
      css,
      styleId,
    } = useClassName(
      {
        display: 'inline-block',
        flexShrink: 0,
        verticalAlign: 'middle',
        ...(typeof fontSize === 'string' ? { width: fontSize, height: fontSize } : null),
        ...sx,
      },
      undefined,
      className,
    );
    return (
      <>
        {styleRule(styleId, css)}
        <LucideIconComponent
          aria-hidden
          className={resolvedClass}
          size={typeof fontSize === 'number' ? fontSize : 24}
          color={typeof color === 'string' ? color : 'currentColor'}
          {...rest}
        />
      </>
    );
  };
}

export const ArrowForwardIcon = makeIcon(ArrowRight);
export const ArrowBackIcon = makeIcon(ArrowLeft);
export const MenuIcon = makeIcon(Menu);
export const ExpandMoreIcon = makeIcon(ChevronDown);
export const AddIcon = makeIcon(Plus);
export const DeleteIcon = makeIcon(Trash2);
export const SchoolIcon = makeIcon(GraduationCap);
export const RocketLaunchIcon = makeIcon(Rocket);
export const GroupsIcon = makeIcon(Users);
export const PersonIcon = makeIcon(User);
export const EmojiEventsIcon = makeIcon(Trophy);
export const InstagramIcon = makeIcon(Instagram);
export const AlternateEmailIcon = makeIcon(AtSign);
export const VideocamIcon = makeIcon(Video);
export const PlayArrowIcon = makeIcon(Play);
export const PauseIcon = makeIcon(Pause);
export const CheckCircleIcon = makeIcon(CircleCheck);
export const SkipNextIcon = makeIcon(SkipForward);
export const MailIcon = makeIcon(Mail);
